import { createFileRoute, Navigate } from '@tanstack/react-router';
import { pageTitle } from '@/utils/pageTitle';
import { IncomeTable } from '@/components/Pages/Incomes/IncomeTable';
import { Box } from '@mui/joy';
import { CreateEditIncomeModal } from '@/components/Pages/Incomes/CreateEditIncomeModal';
import { useAuth } from '@/contexts/AuthContext';

export const Route = createFileRoute('/_protected/incomes/')({
  component: IncomesPage,
  head: () => pageTitle('Ingresos'),
});

function IncomesPage() {
  const { hasClaim, isLoading } = useAuth();
  const canRead = hasClaim('INCOMES_READ');
  const canWrite = hasClaim('INCOMES_WRITE');

  if (!isLoading && !canRead) {
    return <Navigate to='/' />;
  }

  return (
    <Box>
      {canWrite && (
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 3 }}>
          <CreateEditIncomeModal />
        </Box>
      )}
      <IncomeTable
        initialFilters={{ categoryLedger: 'Income' }}
        emptyMessage='No hay ingresos disponibles'
        errorTitle='Error al cargar los ingresos'
      />
    </Box>
  );
}
